export { MorphemeInfoPanelDictionaryGradeBadge } from "#morpheme-info-panel-dictionary-grade-badge";
export { useMorphemeInfoPanelDictionaryGradeLabel } from "#use-morpheme-info-panel-dictionary-grade-label";
